import * as types from 'store/constants';

export const getFavoriteList = item => dispatch => {
	dispatch({ type: types.LOADING_FAVORITE_ITEMS });
};

export const fetchFavoriteList = item => dispatch => {
	dispatch({ type: types.FETCH_FAVORITE_ITEMS, payload: item });
};

export const addToFavorite = (item, callback) => dispatch => {
	dispatch({ type: types.ADD_TO_FAVORITE, payload: item });
	callback();
};

export const removeFromFavorite = (item, callback) => dispatch => {
	dispatch({ type: types.REMOVE_FROM_FAVORITE, payload: item });
	callback();
};

export const updateFavoriteItem = item => dispatch => {
	dispatch({ type: types.UPDATE_FAVORITE_ITEMS, payload: item });
};

export const removeFavoriteItem = item => dispatch => {
	dispatch({ type: types.REMOVE_FROM_FAVORITE_ITEMS, payload: item });
};
export const clearFavorite = () => dispatch => {
	dispatch({ type: types.CLAER_FAVORITE_LIST });
};
